import React, { useState, useEffect, useRef } from "react";
import config from "config";
import Image from "../../../../Elements/Image/Image.tsx";
import EmbedFormTemplate from "../../../../Reusable/EmbedFormTemplate/EmbedFormTemplate.js";
import { useContent } from "../../../../../contexts/contentContext/contentContext.js";

const PreviewForm = ({
  submitCallback = null,
  formId,
  width,
  height,
  isPreview = null,
  currentUserId,
  prevStep1 = null,
  formInEmbedPage = null,
  embedPageFormImage = "",
  hideFooter = null,
  includeTitleAndDesc = null,
  brandingColor = null,
  embedPageEditMode = null,
  activeFormInJumboFormsPage = null,
  handleFinishUploadProcess = () => handleFinishUploadProcess,
}) => {
  const iframeRef = useRef();
  const [loading, setLoading] = useState(false);
  const { getTextByKey } = useContent();

  //config.baseurl
  let baseUrl = config.baseurl;
  if (baseUrl.includes(":3000")) {
    const temp = baseUrl.split(":3000");
    baseUrl = temp[0];
  }
  return (
    <div className={`preview-form-modal ${isPreview ? "is-preview" : ""}`}>
      {isPreview && (
        <div className="preview-title">
          <h1>{getTextByKey("preview")}</h1>
        </div>
      )}
      <div className="top-section">
        <div className={`modal-content ${loading}`}>
          <EmbedFormTemplate
            activeFormInJumboFormsPage={activeFormInJumboFormsPage}
            isPreview={isPreview}
            handleFinishUploadProcess={handleFinishUploadProcess}
            formId={formId}
            prevStep1={prevStep1}
            embedPageFormImage={embedPageFormImage}
            formInEmbedPage={formInEmbedPage}
            hideFooter={hideFooter}
            embedPageEditMode={embedPageEditMode}
            includeTitleAndDesc={includeTitleAndDesc}
            brandingColor={brandingColor}
          />
          {loading && (
            <div
              className="loading-container-form"
              style={{ height: `${height}px`, width: `${width}px` }}
            >
              <Image name="preloader" ext="gif" alt="" title="" />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
//

export default PreviewForm;
